(function () {
  function initScrollRoot(root) {
    if (!root || root.dataset.sussiScrollReady === 'true') return;

    var track = root.querySelector('[data-sussi-scroll-track]');
    if (!track) return;

    var prev = root.querySelector('[data-sussi-scroll-prev]');
    var next = root.querySelector('[data-sussi-scroll-next]');
    var count = root.querySelector('[data-sussi-scroll-count]');
    var firstItem = function () {
      return track.querySelector(':scope > *');
    };
    var scrollStep = function () {
      var item = firstItem();
      var itemWidth = item.getBoundingClientRect().width || 1;
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || 0) || 0;
      return Math.max(itemWidth + gap, 1);
    };
    var currentIndex = function () {
      var total = track.children.length;
      if (!firstItem() || !total) return 0;
      return Math.min(total - 1, Math.max(0, Math.round(track.scrollLeft / scrollStep())));
    };
    var scrollToIndex = function (index, behavior) {
      var total = track.children.length;
      if (!total) return;
      var nextIndex = Math.min(total - 1, Math.max(0, index));
      track.scrollTo({ left: nextIndex * scrollStep(), behavior: behavior || 'smooth' });
    };
    var amount = function () {
      return Math.max(track.clientWidth * 0.82, 280);
    };
    var updateCount = function () {
      if (!count) return;
      var total = track.children.length;
      if (!firstItem() || !total) return;
      var current = currentIndex() + 1;
      count.textContent = current + ' / ' + total;
    };

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -amount(), behavior: 'smooth' });
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: amount(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', updateCount, { passive: true });
    window.addEventListener('resize', updateCount);

    if (root.classList.contains('sussi-kol') || root.classList.contains('sussi-world')) {
      var snapAfterDrag = root.classList.contains('sussi-kol');
      var drag = {
        active: false,
        moved: false,
        suppressClick: false,
        pointerId: null,
        startX: 0,
        startScrollLeft: 0
      };

      track.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'touch' || event.button !== 0 || track.children.length < 2) return;
        drag.active = true;
        drag.moved = false;
        drag.pointerId = event.pointerId;
        drag.startX = event.clientX;
        drag.startScrollLeft = track.scrollLeft;
        track.classList.add('is-dragging');
        track.setPointerCapture(event.pointerId);
      });

      track.addEventListener('pointermove', function (event) {
        if (!drag.active || event.pointerId !== drag.pointerId) return;
        var delta = event.clientX - drag.startX;
        if (Math.abs(delta) > 4) drag.moved = true;
        if (!drag.moved) return;
        event.preventDefault();
        track.scrollLeft = drag.startScrollLeft - delta;
        updateCount();
      });

      var endDrag = function (event) {
        if (!drag.active || event.pointerId !== drag.pointerId) return;
        drag.active = false;
        track.classList.remove('is-dragging');
        try { track.releasePointerCapture(event.pointerId); } catch (error) {}
        if (drag.moved) {
          drag.suppressClick = true;
          window.setTimeout(function () {
            drag.suppressClick = false;
          }, 120);
          if (snapAfterDrag) scrollToIndex(currentIndex(), 'smooth');
        }
        drag.pointerId = null;
      };

      track.addEventListener('click', function (event) {
        if (!drag.suppressClick) return;
        event.preventDefault();
        event.stopImmediatePropagation();
      }, true);

      track.addEventListener('dragstart', function (event) {
        event.preventDefault();
      });

      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('lostpointercapture', function () {
        if (!drag.active) return;
        drag.active = false;
        track.classList.remove('is-dragging');
        if (drag.moved) {
          drag.suppressClick = true;
          window.setTimeout(function () {
            drag.suppressClick = false;
          }, 120);
          if (snapAfterDrag) scrollToIndex(currentIndex(), 'smooth');
        }
        drag.pointerId = null;
      });
    }

    updateCount();

    root.dataset.sussiScrollReady = 'true';
  }

  var scrollRootObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          initScrollRoot(entry.target);
        });
      }, { rootMargin: '600px 0px' })
    : null;

  function scheduleScrollRoot(root) {
    if (!root || root.dataset.sussiScrollReady === 'true') return;
    if (!scrollRootObserver) {
      initScrollRoot(root);
      return;
    }
    scrollRootObserver.observe(root);
  }

  function hydrateDeferredMedia(root) {
    if (!root || root.dataset.sussiDeferredMediaReady === 'true') return;

    root.querySelectorAll('[data-manual-srcset]').forEach(function (media) {
      media.srcset = media.dataset.manualSrcset;
      media.removeAttribute('data-manual-srcset');
    });
    root.querySelectorAll('img[data-manual-src]').forEach(function (image) {
      image.src = image.dataset.manualSrc;
      image.removeAttribute('data-manual-src');
      image.loading = 'eager';
    });

    root.dataset.sussiDeferredMediaReady = 'true';
  }

  var deferredMediaObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          hydrateDeferredMedia(entry.target);
        });
      }, { rootMargin: '600px 0px' })
    : null;

  var deferredMediaActivated = window.scrollY > 0;

  function scheduleDeferredMedia(root) {
    if (!root || root.dataset.sussiDeferredMediaReady === 'true') return;
    if (!deferredMediaObserver) {
      hydrateDeferredMedia(root);
      return;
    }
    if (!deferredMediaActivated) {
      root.dataset.sussiDeferredMediaWaiting = 'true';
      return;
    }
    deferredMediaObserver.observe(root);
  }

  function activateDeferredMedia() {
    if (deferredMediaActivated) return;
    deferredMediaActivated = true;
    document.querySelectorAll('[data-sussi-deferred-media-waiting]').forEach(function (root) {
      root.removeAttribute('data-sussi-deferred-media-waiting');
      scheduleDeferredMedia(root);
    });
  }

  window.addEventListener('scroll', function () {
    if (window.scrollY > 0) activateDeferredMedia();
  }, { passive: true });

  function init(container) {
    (container || document).querySelectorAll('[data-sussi-scroll-root]').forEach(scheduleScrollRoot);
    (container || document).querySelectorAll('[data-sussi-deferred-media-root]').forEach(scheduleDeferredMedia);
    (container || document).querySelectorAll('[data-sussi-hero-root]').forEach(initHeroRoot);
  }

  function initHeroRoot(root) {
    if (!root || root.dataset.sussiHeroReady === 'true') return;

    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-sussi-hero-panel]'));
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-sussi-hero-index-button]'));
    var indices = panels
      .map(function (panel) { return Number(panel.dataset.sussiHeroPanelIndex || 0); })
      .filter(function (value, index, array) { return array.indexOf(value) === index; })
      .sort(function (a, b) { return a - b; });

    if (!indices.length) return;

    var activeIndex = -1;
    var hydratePanelMedia = function (index) {
      panels.forEach(function (panel) {
        var panelIndex = Number(panel.dataset.sussiHeroPanelIndex || 0);
        if (panelIndex !== index || window.getComputedStyle(panel).display === 'none') return;

        panel.querySelectorAll('[data-sussi-hero-lazy-media]').forEach(function (image) {
          var source = image.dataset.sussiSrc;
          var sourceSet = image.dataset.sussiSrcset;
          if (!source && !sourceSet) return;

          image.loading = 'eager';
          if (sourceSet) image.srcset = sourceSet;
          if (source) image.src = source;
          image.removeAttribute('data-sussi-src');
          image.removeAttribute('data-sussi-srcset');
          image.removeAttribute('data-sussi-hero-lazy-media');
        });
      });
    };

    var setActive = function (index) {
      index = Math.max(0, Math.min(indices.length - 1, index));
      hydratePanelMedia(index);
      if (index === activeIndex) return;

      panels.forEach(function (panel) {
        var panelIndex = Number(panel.dataset.sussiHeroPanelIndex || 0);
        var isActive = panelIndex === index;
        panel.classList.toggle('is-active', isActive);
        panel.classList.toggle('active', isActive);
        panel.classList.toggle('is-leaving', activeIndex >= 0 && panelIndex === activeIndex && !isActive);
      });

      buttons.forEach(function (button) {
        var buttonIndex = Number(button.dataset.sussiHeroPanelIndex || 0);
        var isActive = buttonIndex === index;
        button.classList.toggle('is-active', isActive);
        button.classList.toggle('active', isActive);
      });

      activeIndex = index;
    };

    var updateFromScroll = function () {
      if (window.scrollY > 0) {
        root.querySelectorAll('[data-sussi-hero-initial]').forEach(function (panel) {
          panel.removeAttribute('data-sussi-hero-initial');
        });
      }
      var rect = root.getBoundingClientRect();
      var viewport = window.innerHeight || document.documentElement.clientHeight || 1;
      var available = Math.max(1, rect.height - viewport);
      var progress = Math.max(0, Math.min(1, -rect.top / available));
      var scaledProgress = progress * (indices.length - 1);
      var nextIndex = Math.min(indices.length - 1, Math.floor(scaledProgress + 0.75));
      hydratePanelMedia(nextIndex);
      setActive(Math.round(scaledProgress));
    };

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        armHeroInteraction();
        var index = Number(button.dataset.sussiHeroPanelIndex || 0);
        hydratePanelMedia(index);
        var viewport = window.innerHeight || document.documentElement.clientHeight || 1;
        var target = root.getBoundingClientRect().top + window.scrollY + index * Math.max(viewport * 0.72, 360);
        window.scrollTo({ top: target, behavior: 'smooth' });
      });
    });

    var interactionArmed = false;
    var armHeroInteraction = function () {
      if (interactionArmed) return;
      interactionArmed = true;
      root.dataset.sussiHeroInteracted = 'true';
      window.addEventListener('scroll', updateFromScroll, { passive: true });
      updateFromScroll();
    };

    window.addEventListener('wheel', armHeroInteraction, { passive: true, once: true });
    window.addEventListener('touchstart', armHeroInteraction, { passive: true, once: true });
    window.addEventListener('pointerdown', armHeroInteraction, { passive: true, once: true });
    window.addEventListener('keydown', armHeroInteraction, { once: true });
    window.addEventListener('resize', updateFromScroll);
    setActive(0);
    root.dataset.sussiHeroReady = 'true';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
